import { IssueUserInfo } from 'pages/Desk/issues/types';
import { UserDetails } from 'pages/Desk/issues/UserDetails';
import { useEffect, useRef } from 'react';
import styled from 'styled-components';
import { tokens } from 'styles/tokens';

const Container = styled.button<{ $isHighlighted?: boolean }>`
    display: block;
    border: none;
    background: ${({ $isHighlighted }) =>
        $isHighlighted ? tokens.background.subtle : 'none'};
    text-align: left;
    cursor: pointer;

    &:hover {
        background: ${tokens.background.subtle};
    }
`;

export type UserResultProps = Readonly<{
    user: IssueUserInfo;
    searchTokens: string[];
    isHighlighted?: boolean;
    autoScroll?: boolean;
    onClick: (user: IssueUserInfo) => void;
}>;

export function UserResult({
    user,
    searchTokens,
    isHighlighted,
    autoScroll = false,
    onClick,
}: UserResultProps) {
    const ref = useRef<HTMLButtonElement>(null);

    useEffect(() => {
        if (isHighlighted && autoScroll) {
            ref.current?.scrollIntoView({ behavior: 'auto', block: 'nearest' });
        }
    }, [autoScroll, isHighlighted]);

    return (
        <Container
            ref={ref}
            $isHighlighted={isHighlighted}
            aria-selected={isHighlighted}
            onClick={() => onClick(user)}
        >
            <UserDetails searchTerms={searchTokens} user={user} />
        </Container>
    );
}
